/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import BulkActions from './BulkActions/index'
import Filters from './Filters/index'
import React from 'react'
import Tasks from './Tasks/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let selectedBulkTaskIdsValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'bulk_task_ids',
format: fromFormat.isNotEmptyList,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bbc-1-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Filters
  viewPath={`${viewPath}/Filters`}
/>
<fromFlow.When is={selectedBulkTaskIdsValueData}>
<BulkActions
  viewPath={`${viewPath}/BulkActions`}
 data="selected.bulk_task_ids"
 format="/Data/format.js isNotEmptyList"
/>
</fromFlow.When>
</div>
<Tasks
  viewPath={`${viewPath}/Tasks`}
/>
{children}
</React.Fragment>)
}